import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    effect,
    ElementRef,
    input,
    InputSignal,
    signal,
    Signal,
    viewChild,
    WritableSignal
} from "@angular/core";
import QRCode from "qrcode";

@Component({
    selector: "woa-qr-code",
    templateUrl: "./qr-code.component.html",
    styleUrl: "./qr-code.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrCodeComponent implements AfterViewInit {
    public readonly value: InputSignal<string> = input.required<string>();
    public readonly width: InputSignal<number> = input<number>(200);
    public readonly foreground: InputSignal<string> = input<string>("#000000");
    public readonly background: InputSignal<string> = input<string>("#FFFFFF");
    public readonly errorCorrectionLevel: InputSignal<"L" | "M" | "Q" | "H"> = input<"L" | "M" | "Q" | "H">("M");

    private readonly canvas: Signal<ElementRef<HTMLCanvasElement>> = viewChild.required<ElementRef<HTMLCanvasElement>>("canvas");

    private initialised: WritableSignal<boolean> = signal(false);

    constructor() {
        effect(() => {
            if (!this.initialised() || !this.value()) {
                return;
            }
            QRCode.toCanvas(this.canvas().nativeElement, this.value(), {
                width: this.width(),
                margin: 1,
                errorCorrectionLevel: this.errorCorrectionLevel(),
                color: {
                    dark: this.foreground(),
                    light: this.background()
                }
            }).catch((error: Error) => {
                console.error("QR Code generation failed:", error);
            });
        });
    }

    public ngAfterViewInit(): void {
        this.initialised.set(true);
    }
}
